<template>
  <div></div>
</template>

<script>
export default {
  methods: {
    open() {
      var paddle = window.Paddle;
      paddle.Spinner.show();
    },
    close() {
      var paddle = window.Paddle;
      paddle.Spinner.hide();
    },
  },
};
</script>

<style scoped></style>
